import 'core-js/fn/object/assign';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, IndexRoute, hashHistory, browserHistory } from 'react-router';
import configureStore from './stores';

const store = configureStore();

import App    from './containers/App';
import Top    from './containers/Top';
import Single from './containers/Single';

render(
  <Provider store={store}>
    <Router history={hashHistory}>
      <Route path='/' component={App}>
        <IndexRoute component={Top} />
        <Route name='top' path='/' component={Top} />
        <Route name='single' path='/:slug' component={Single} />
      </Route>
    </Router>
  </Provider>,
  document.getElementById('app')
);




// WEBPACK FOOTER //
// ./src/index.js